import React from "react";
import logo from './logo.svg';
import {
    useJWT,
    JWTProvider
} from './JWT';
import BotHome from './BotHome';
import Secrets from './Secrets';
import Dashboard from './Dashboard';
import Logs from './Logs';
import { HelpoverInputGroup } from './Helpover';
import {
    BrowserRouter,
    Switch,
    Route,
    Redirect,
    Link,
    NavLink,
    useHistory,
    useLocation,
    useRouteMatch,
    useParams
} from "react-router-dom";
import {
    BiLogIn,
    BiLogOut,
    BiReplyAll
} from "react-icons/bi";
import Alert from 'react-bootstrap/Alert';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Modal from 'react-bootstrap/Modal';
import InputGroup from 'react-bootstrap/InputGroup';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

function TopNav() {
    const jwt = useJWT();
    const history = useHistory();
    const [signingup, setSigningup] = React.useState(false);

    return (
      <>
        <Modal size="lg" show={signingup} onHide={() => setSigningup(false)}>
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body>
            <Signup onComplete={() => {setSigningup(false)}}/>
          </Modal.Body>
        </Modal>

        <Navbar bg="dark">
          <Navbar.Brand href="/">
            <Image src={logo} width="30" height="30" className="d-inline-block align-top"/>
            <span className="font-weight-bold text-danger">BETA!!1</span>
          </Navbar.Brand>
          <Nav className="ml-auto">
        { jwt.claims ? (
            <>
              <Navbar.Text><Link to="/dashboard">{jwt.claims.sub}</Link></Navbar.Text>
              <Button size="sm" variant="link" onClick={() => {jwt.deleteToken(() => { history.push("/"); })}}><BiLogOut />sign out</Button>
            </>
          ) : (
            <>
              <Login />
              <Button variant="primary" size="sm" onClick={() => setSigningup(true)}>
                sign up
              </Button>
            </>
          )
        }
          </Nav>
        </Navbar>
      </>
    )
}

function BottomNav() {
    return (
        <>
        <hr/>
        <Nav className="justify-content-center">
          <Nav.Item>
            <Nav.Link href={`https://docs.${process.env.REACT_APP_DOMAIN}/`}>documentation</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="https://discord.gg/4xSXp6sFN">discord us</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="mailto:support@allthebots.dev">email us</Nav.Link>
          </Nav.Item>
        </Nav>
        </>
    );
}

function Signup(props) {
    const [email, setEmail] = React.useState("");
    const [nonce, setNonce] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [namespace, setNamespace] = React.useState("");
    // 0 -> send email verification, 1 -> enter nonce, 2 -> create account
    const [stage, setStage] = React.useState(0);
    const [stage0working, setStage0working] = React.useState(false);
    const [stage0error, setStage0error] = React.useState("");
    const [stage1working, setStage1working] = React.useState(false);
    const [stage1error, setStage1error] = React.useState("");
    const [stage2working, setStage2working] = React.useState(false);
    const [stage2error, setStage2error] = React.useState("");

    const jwt = useJWT();
    const history = useHistory();
    const location = useLocation();

    let { from } = location.state || { from: { pathname: "/"  } };

    async function handleCreateEmailVerification(event) {
        event.preventDefault();

        setStage0working(true);
        fetch(`https://api.${process.env.REACT_APP_DOMAIN}/rest/email_verifications`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'email': email
            })
        }).then(response => {
            if (!response.ok) {
                throw new Error(`${response.status} ${response.statusText}`);
            }
            return response
        }).then(payload => {
            setStage0error("");
            setStage0working(false);
            setStage(1);
        }).catch(error => {
            console.error("creating an email verification: ", error);
            setStage0error(error);
            setStage0working(false);
        });
    }

    async function handleVerifyEmail(event) {
        event.preventDefault();

        setStage1working(true);
        fetch(`https://api.${process.env.REACT_APP_DOMAIN}/rest/email_verifications/${email}/${nonce}`, {
            method: 'GET'
        }).then(response => {
            if (!response.ok) {
                throw new Error(`${response.status} ${response.statusText}`);
            }
            return response
        }).then(payload => {
            setStage1error("");
            setStage1working(false);

            let suggested_namespace = email.split('@', 2)[0].toLowerCase().replace(/[^0-9a-z]/g, '');
            setNamespace(suggested_namespace);

            setStage(2);
        }).catch(error => {
            console.error("verifying email: ", error);
            setStage1error(error);
            setStage1working(false);
        });
    }

    async function handleCreateAccount(event) {
        event.preventDefault();

        setStage2working(true);
        fetch(`https://api.${process.env.REACT_APP_DOMAIN}/rest/accounts`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'email': email,
                'nonce': nonce,
                'namespace': namespace,
                'password': password
            })
        }).then(response => {
            if (!response.ok) {
                throw new Error(`${response.status} ${response.statusText}`);
            }
            return response
        }).then(payload => {
            setStage2error("");
            setStage2working(false);
            handleLogin(jwt, email, password, history, from);
            props.onComplete();
        }).catch(error => {
            console.error("verifying email: ", error);
            setStage2error(error);
            setStage2working(false);
        });
    }

    if (stage === 0) {
        return (
          <>
            {stage0error &&
               (<Alert variant="danger">
                   {stage0error.message}
                </Alert>)}
            <Alert variant="info">
              we'll send a 6 digit code to this address, to confirm it's really you.
            </Alert>
            <Form onSubmit={handleCreateEmailVerification}>
              <Form.Row>
                <InputGroup className="mb-3">
                  <Form.Control type="email" placeholder="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                  <HelpoverInputGroup topic="email"/>
                </InputGroup>
              </Form.Row>
              <Form.Row>
                <Button variant="primary" block size="sm" type="submit" disabled={stage0working}>
                  send me a code!
                </Button>
              </Form.Row>
            </Form>
          </>
        );
    }
    if (stage === 1) {
        return (
          <>
            {stage1error &&
               (<Alert variant="danger">
                   {stage1error.message}
                </Alert>)}
            <Alert variant="info">
              check <span className="font-weight-bold">{email}</span> for a message from allthebots, and enter the 6 digit code below:
            </Alert>
            <Form onSubmit={handleVerifyEmail}>
              <Form.Row>
                <InputGroup className="mb-3">
                  <Form.Control placeholder="6 digit code" autoComplete="one-time-code" value={nonce} onChange={(e) => setNonce(e.target.value)} />
                  <HelpoverInputGroup topic="nonce"/>
                </InputGroup>
              </Form.Row>
              <Form.Row>
                <Button variant="primary" block size="sm" type="submit" disabled={stage1working}>
                  this is the code!
                </Button>
              </Form.Row>
            </Form>
          </>
        );
    }
    if (stage === 2) {
        return (
          <>
            {stage2error &&
               (<Alert variant="danger">
                   {stage2error.message}
                </Alert>)}
            <Alert variant="info">
              almost there! just choose a namespace and a password!
            </Alert>
            <Form onSubmit={handleCreateAccount}>
              <Form.Row>
                <InputGroup className="mb-3">
                  <Form.Control placeholder="namespace" value={namespace} onChange={(e) => setNamespace(e.target.value)} />
                  <HelpoverInputGroup topic="namespace"/>
                </InputGroup>
              </Form.Row>
              <Form.Row>
                <InputGroup className="mb-3">
                  <Form.Control type="password" autoComplete="new-password" placeholder="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                  <HelpoverInputGroup topic="password"/>
                </InputGroup>
              </Form.Row>
              <Form.Row>
                <Button variant="primary" block size="sm" type="submit" disabled={stage2working}>
                  bam!
                </Button>
              </Form.Row>
            </Form>
          </>
        );
    }
}

function App() {
    return (
      <ConfigProvider>
        <JWTProvider>
        <BrowserRouter>
          <TopNav />
          <Container fluid className="mt-4">
            <Switch>
              <Route path="/" exact><Home /></Route>
              {/* note that all "exact" routes must be disallowed as namespaces, to avoid confusion with the bot routes */}
              <PrivateRoute path="/dashboard" exact><Dashboard /></PrivateRoute>
              <PrivateRoute path="/:namespace/:handle/"><Bot /></PrivateRoute>
              <PrivateRoute path="/_paypal" exact><Paypal /></PrivateRoute>
              <Route path="*"><Confused /></Route>
            </Switch>
          </Container>
          <BottomNav />
        </BrowserRouter>
        </JWTProvider>
      </ConfigProvider>
    );
}

function Bot() {
    const { path, url } = useRouteMatch();
    const { namespace, handle } = useParams();

    return (
        <>
          <Link to="/dashboard"><BiReplyAll/></Link>
          <Nav variant="tabs">
            <Nav.Item>
              <NavLink role="tab" className="nav-link" exact to={url}><span className="font-weight-bold">{namespace}/{handle}</span></NavLink>
            </Nav.Item>
            <Nav.Item>
              <NavLink role="tab" className="nav-link" to={url + "/secrets"}>secrets</NavLink>
            </Nav.Item>
            <Nav.Item>
              <NavLink role="tab" className="nav-link" to={url + "/logs"}>logs</NavLink>
            </Nav.Item>
          </Nav>
          <Switch>
            <PrivateRoute exact path={path}><BotHome /></PrivateRoute>
            <PrivateRoute path={path + "logs"}><Logs /></PrivateRoute>
            <PrivateRoute path={path + "secrets"}><Secrets /></PrivateRoute>
          </Switch>
        </>
    );
}

function PrivateRoute({ children, ...rest }) {
    const jwt = useJWT();

    return (
      <Route
        {...rest}
        render={({ location }) =>
          jwt.claims ? (
            children
          ) : (
            <Redirect to={{ pathname: "/", state: { from: location } }} />
          )
        }
      />
    );
}

function Home() {
  const jwt = useJWT();
  const [signingup, setSigningup] = React.useState(false);

    if (jwt.claims) {
        return (
            <Redirect to={{ pathname: "/dashboard" }}/>
        )
    }

  return (
    <>
    <Modal size="lg" show={signingup} onHide={() => setSigningup(false)}>
      <Modal.Header closeButton>
      </Modal.Header>
      <Modal.Body>
        <Signup onComplete={() => {setSigningup(false)}}/>
      </Modal.Body>
    </Modal>

    <Container fluid>
      <Row>
        <Col>
          <h2 className="text-nowrap">
          cheap, minimal hosting for chat bots
          </h2>

          <Container>
            <h3>cheap?</h3>
            <ul>
              <li>sign up with <span className="font-weight-bold">just an email address</span> to try it, free, for 10 days.</li>
              <li><span className="font-weight-bold">$1/month</span> (or less!) per bot thereafter.</li>
              <li>(no ads or spam, either. nobody is trying to get rich, here.)</li>
            </ul>

            <h3>minimal hosting?</h3>
            <ul>
              <li>starting to code a chat bot is easy; our goal is to make starting to <span className="font-weight-bold">host</span> a chat bot just as easy.</li>
              <li>you <code>docker push</code> an image, we keep it running in an itty-bitty stateless container. that's it.</li>
              <li>(your bot might outgrow what we offer, and that's okay! you haven't committed to anything but docker.)</li>
            </ul>

            <h3>chat bots?</h3>
            <ul>
              <li>allthebots is oriented around hosting chat bots.</li>
              <li>we have a couple of bells and whistles specifically for discord bots.</li>
              <li>(but if you want to run something other than a chat bot, go for it!)</li>
            </ul>
          </Container>

        </Col>
      </Row>
      <Row>
        <Col>
          <Button size="lg" variant="primary" onClick={() => setSigningup(true)}>try it out!</Button>
        </Col>
      </Row>
    </Container>
    </>
  );
}

async function handleLogin(jwt, email, password, history, from) {
    fetch(`https://api.${process.env.REACT_APP_DOMAIN}/app/token`, {
        method: 'GET',
        headers: {
            'Authorization': 'Basic ' + btoa(`${email}:${password}`)
        },
    }).then(response => {
        if (!response.ok) {
            throw new Error(`${response.status} ${response.statusText}`);
        }
        return response.json();
    }).then(payload => {
        jwt.saveToken(payload.token, () => {
            history.replace(from)
        });
    }).catch(error => {
        console.error("fetching token: ", error);
    });
}


function Login() {
    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");

    const history = useHistory();
    const location = useLocation();
    const jwt = useJWT();

    let { from } = location.state || { from: { pathname: "/"  } };

    return (
      <Form onSubmit={(e) => { e.preventDefault(); handleLogin(jwt, email, password, history, from) }}>
        <Form.Row>
          <Col>
            <Form.Control type="email" placeholder="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </Col>
          <Col>
            <Form.Control type="password" placeholder="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </Col>
          <Col>
            <Button variant="outline-primary" size="sm" type="submit">
              <BiLogIn/>sign in
            </Button>
          </Col>
        </Form.Row>
      </Form>
    );
}

function Confused() {
    return (
      <Container className="ml-auto mr-auto">
        <Row>
          <Image src={logo} className="ml-auto mr-2" width="35%" style={{transform: "rotate(180deg)"}}/>
          <div className="mr-auto">
            <Alert variant="danger">
              You lost me.
            </Alert>
          </div>
        </Row>
      </Container>
    );
}

const configContext = React.createContext()

function useConfig() {
    return React.useContext(configContext);
}

function useProvideConfig() {
    const [configuration, setConfiguration] = React.useState('loading');

    React.useEffect(() => {
        fetch(`https://api.${process.env.REACT_APP_DOMAIN}/app/configuration`).then(response => {
            if (!response.ok) {
                throw new Error(`${response.status} ${response.statusText}`);
            }
            return response.json()
        }).then(json => {
            setConfiguration(json);
        })
    }, []);

    return configuration;
}

function ConfigProvider({ children, ...rest }) {
    const config = useProvideConfig();
    return (
        <configContext.Provider value={config}>
        {children}
        </configContext.Provider>
    )
}

function Payment() {
    const config = useConfig();
    const jwt = useJWT();
    const [quantity, setQuantity] = React.useState(1);
    const [frequency, setFrequency] = React.useState('month');

    let cost = () => {
        let first = (frequency === "month") ? 100 : 1140;
        let rest = (frequency === "month") ? 95 : 1135;
        return ((first + (rest * (quantity - 1))) / 100).toFixed(2);
    };

    return (
        <>
          <Form.Group>
            <Form.Label>how many bots?</Form.Label>
            <Form.Control type="range" min="1" max="10" value={quantity} onChange={(e) => setQuantity(e.target.value)}/>
          </Form.Group>
          <Form.Group>
            <Form.Check type="checkbox" label="yearly?" onChange={(e) => {
                if (e.target.checked) {
                    setFrequency('year');
                } else {
                    setFrequency('month');
                }
            }}/>
          </Form.Group>
          <>
            {quantity} bot(s): ${cost()} / {frequency}
          </>
          <PayPalButtons style={{
              "layout": "vertical",
          }} createSubscription={(data, actions) => {
              let plan_id = (frequency === "month")
                               ? config.paypal_monthly_plan_id
                               : config.paypal_yearly_plan_id;
              console.log(`${quantity} of ${plan_id} (${frequency})`);
              return actions.subscription.create({
                  'plan_id': plan_id,
                  'quantity': quantity,
                  'custom_id': jwt.claims.sub,
                  'application_context': {
                      'brand_name': process.env.REACT_APP_DOMAIN,
                      'shipping_preference': 'NO_SHIPPING',
                      'user_action': 'SUBSCRIBE_NOW'
                  }
              });
          }} forceReRender={cost()}/>
      </>
    );
}

function Paypal() {
    const config = useConfig();

    if (config === "loading") {
        console.debug("rendering blocked until config loading completes");
        return null;
    }
    return (
        <PayPalScriptProvider options={{
            "client-id": config.paypal_client_id,
            "vault": true,
            "intent": "subscription"
        }}>
          <Payment />
        </PayPalScriptProvider>
    );
}

export default App;
